import { render, staticRenderFns } from "./user-withdrawal-list.vue?vue&type=template&id=83515dd6&scoped=true&"
import script from "./user-withdrawal-list.vue?vue&type=script&lang=js&"
export * from "./user-withdrawal-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83515dd6",
  null
  
)

export default component.exports